import { render, staticRenderFns } from "./category_result.vue?vue&type=template&id=79aadc36&"
import script from "./category_result.vue?vue&type=script&lang=js&"
export * from "./category_result.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports